
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("ember-tracked-storage-polyfill/index", function(){ return i("ember-tracked-storage-polyfill/index");});
import "ember-tracked-storage-polyfill/-embroider-implicit-modules.js";
